import { createSelector } from 'reselect';
import { MeState } from '.';

export const getRoot = (state: any) => {
  return state.me as MeState;
};

export const getMeList = createSelector([getRoot], state => state.meList);
